import React from 'react'
import '../Footer/Footer.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { Config } from '../../Config'
import AuthenticationService from '../Security/AuthenticationService'

export default class Footer extends React.Component {
  constructor (props) {
    super(props)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      token: this.authService.getToken(),
      year : new Date().getFullYear()
    }
    // this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.url = Config.storageUrl
  }
  render () {
    return (<div >
      <div className={(!this.authService.isAdmin() ? 'Footer ' : 'FooterAdmin ') + (window.location.pathname.indexOf('/storeRanking') !== -1 ? 'hidden' : '')}>
        <div className={'copyright ' + (this.authService.isAdmin() ? 'copyrightAdmin' : 'copyrightClient')}>
          <span><b>HM Electronics, Inc. &copy;{this.state.year} </b>
            {this.renderClientFooters()}
          </span></div>
      </div>
    </div>)
  }
  renderClientFooters () {
    const { url } = this.state
    const language = this.state.currentLanguage
    if (!this.authService.isAdmin()) {
      return (<span>|
      <a className='terms red_link' href={url + '/' + t[language].useragreementUrl} target='_blank'>{t[language].useragreement}</a>                      |
      <a className='privacy red_link' href={url + '/' + t[language].privacypolicyUrl} target='_blank'>{t[language].privacypolicy}</a>      |
      <a className='supply red_link' href={url + '/' + t[language].californiasupplyUrl} target='_blank'>{t[language].californiasupply}</a>                      |
      <a className='cookie red_link' href={url +  '/' + t[language].cookiepolicyUrl} target='_blank'>{t[language].cookiepolicy}</a>
      </span>)
    } else {
      return (<span />)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js